/* 
On adding product route information request for a product route
params infoType : information type
       data     : form data
*/
export const addProductInfo = (infoType, data, identifier, callback) => {
    return dispatch => {
      dispatch({
        type: 'ADD_PRODUCT_ROUTE_INFO',
        infoType,
        data,
        identifier,
        callback
      })
    }
  }
  
  
/* 
On success of adding product route information request for a product route
params infoType : information type
       data     : response data
*/
export const addProductInfoSuccess = (infoType, data) => {
    return dispatch => {
        dispatch({
            type: 'ADD_PRODUCT_ROUTE_INFO_SUCCESS',
            infoType,
            data
        })
    }
}
  
  
/* 
On failing of adding product route information request for a product route
params infoType : information type
       errors    : errors
*/
export const addProductInfoFail = (infoType, errors) => {
    return dispatch => {
        dispatch({
            type: 'ADD_PRODUCT_ROUTE_INFO_FAIL',
            infoType,
            errors
        })
    }
}


/* 
On updating of product route information request for a product route
params id       : info Id
       infoType : information type
       item     : row data
*/
export const updateProductInfo = (id, infoType, item, identifier, callback) => {
    return dispatch => {
      dispatch({
        type: 'UPDATE_PRODUCT_ROUTE_INFO',
        id,
        infoType,
        item,
        identifier,
        callback
      })
    }
  }
  
  
/* 
On success of updating product route information request for a product route
params id       : info Id
       infoType : information type
       item     : response data
*/
export const updateProductInfoSuccess = (id, infoType, item) => {
    return dispatch => {
        dispatch({
            type: 'UPDATE_PRODUCT_ROUTE_INFO_SUCCESS',
            infoType,
            id,
            item
        })
    }
}
  
  
/* 
On failing of updating product route information request for a product route
params id       : info Id
       infoType : information type
       errors    : errors
*/
export const updateProductInfoFail = (id, infoType, errors) => {
    return dispatch => {
        dispatch({
            type: 'UPDATE_PRODUCT_ROUTE_INFO_FAIL',
            id,
            infoType,
            errors
        })
    }
}


/* 
On deleting product route information
params id : info id
       infoType : information type
*/
export const deleteProductInfo = (id, infoType, identifier) => {
    return dispatch => {
        dispatch({
            type: 'DELETE_PRODUCT_ROUTE_INFO',
            id,
            infoType,
            identifier
        })
    }
  }
  
  
/* 
On success of deleting product route information
params id : info id
       infoType : information type
*/
export const deleteProductInfoSuccess = (id, infoType) => {
    return dispatch => {
        dispatch({
            type: 'DELETE_PRODUCT_ROUTE_INFO_SUCCESS',
            id,
            infoType
        })
    }
}
  
  
/* 
On failing of deleting product route information
params id : info id
       infoType : information type
       errors    : errors
*/
export const deleteProductInfoFail = (id, infoType, errors) => {
    return dispatch => {
        dispatch({
            type: 'DELETE_PRODUCT_ROUTE_INFO_FAIL',
            id,
            infoType,
            errors
        })
    }
}